/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectedProvidersInfo/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SelectedProvidersInfo({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/SelectedProvidersInfo"
  
}) {
let tabSelectedSidebarEmployeeResourcesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.sidebar_employee_resources',
format: fromFormat.isNotEmptyList,
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let constantData = 'Showing availability for'
let tabSelectedSidebarEmployeeResourcesValueData1 = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.sidebar_employee_resources',
format: fromFormat.listLength,
})
let constantData1 = 'providers'
let aggregateData = fromAggregate.join(constantData, tabSelectedSidebarEmployeeResourcesValueData1, constantData1)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let onClick = fromHelpers.useOnClearProviders({
  children,
  viewPath
  
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<fromFlow.When is={tabSelectedSidebarEmployeeResourcesValueData}>
<div
  data-testid="SelectedProvidersInfo.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-d4PQl': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 fontSize={dtTypographyFontsizeM}
 maxWidth="70%"
 data="'Showing availability for'"
 data="tab.selected.sidebar_employee_resources"
 format="/Data/format.js listLength"
 aggregate="/Data/aggregate.js join"
 data="'providers'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 id="providers"
 onClick={onClick}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 text="Clear All"
/>
)}
</TysiaButton>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}